export const OBJECT_RESOURCE_PATH = '/v1/objekt/entities';
export const SOFTLINE_API_OBJEKT_ARCHIVE_KEY = '/v1/objekt/entities/{{id}}/archivekey';
export const SCAN_OBJECT_RESOURCE_PATH = '/v1/objekt/scan/{{type}}/{{id}}';
export const GET_OBJECT_BY_ID_RESOURCE_PATH = '/v1/objekt/entities/{{id}}';
